import { Component, inject, OnInit, signal } from '@angular/core';
import { CoreModule, emailValidator, FormComponent, phoneValidator } from '@toevla-webapplications/core';
import { FormArray, FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BookingService } from '../../../../../../services/booking/booking.service';
import { Store } from '@ngrx/store';
import { IvvaStore } from '../../../../../../store/store.model';
import { User } from '../../../../../../services/user/user.model';
import { take } from 'rxjs';

@Component({
    selector: 'ivva-booking-oh-details',
    templateUrl: './booking-oh-details.component.html',
    styleUrls: ['./booking-oh-details.component.scss'],
    imports: [ReactiveFormsModule, CoreModule, TranslateModule]
})
export class BookingOhDetailsComponent extends FormComponent implements OnInit {
	user = signal<User | null>(null);

	protected readonly GENDERS = ['M', 'V', 'X'];

	private readonly bookingService = inject(BookingService);
	private readonly fb = inject(FormBuilder);
	private readonly store = inject(Store<IvvaStore>);

	get family(): FormArray {
		return this.form?.get('family') as FormArray;
	}

	get guide(): FormArray {
		return this.form?.get('guide') as FormArray;
	}

	ngOnInit() {
		this.store
			.select('offers', 'user')
			.pipe(take(1))
			.subscribe((user) => {
				this.user.set(user);
				this.createForm();
			});
	}

	addFamilyMember(fm?: any) {
		const member = this.fb.group({
			birthDate: [fm?.birthDate, Validators.required],
			fullName: [fm?.fullName, Validators.required],
			gender: [fm?.gender],
		});

		this.family.push(member);
	}

	removeFamilyMember(index: number) {
		this.family.removeAt(index);
	}

	addGuide(g?: any) {
		const guide = this.fb.group({
			firstName: [g?.firstName, Validators.required],
			lastName: [g?.lastName, Validators.required],
			email: [g?.email, [Validators.required, emailValidator]],
			phone: [g?.phone, [Validators.required, phoneValidator]],
			bookingConfirmations: [g?.bookingConfirmations],
		});

		this.guide.push(guide);
	}

	removeGuide(index: number) {
		this.guide.removeAt(index);
	}

	private createForm() {
		const data = this.bookingService.getCurrentBooking();

		this.form = this.fb.group({
			booker: this.fb.group({
				firstName: [data.booker?.firstName || this.user()?.firstName, Validators.required],
				lastName: [data.booker?.lastName || this.user()?.lastName, Validators.required],
				email: [data.booker?.email, [Validators.required, emailValidator]],
				phone: [data.booker?.phone, [Validators.required, phoneValidator]],
				birthDate: [data.booker?.birthDate, Validators.required],
				gender: [data.booker?.gender],
				bookingConfirmations: [data.booker?.bookingConfirmations],
			}),
			family: this.fb.array([]),
			guide: this.fb.array([]),
		});

		if (!this.user()?.socialOrg) {
			this.form.get('booker.firstName')?.disable();
			this.form.get('booker.lastName')?.disable();
		}

		data.family?.forEach((fm: any) => {
			this.addFamilyMember(fm);
		});

		data.guide?.forEach((g: any) => {
			this.addGuide(g);
		});
	}
}
